/**
 * Gère le bloc posts en front
 */
export class Posts{

    //------------------------------------------------ static -------------------------------------------------------

    /**
     * Initialise
     * Cherche dans page les blocs posts
     */
    static init(){
        [...document.querySelectorAll("[data-event=autoload]")].forEach($element => {
            if($element.dataset.route){
                const {base, endpoint, query, view} = JSON.parse($element.dataset.route);
                Posts.html($element, base, endpoint, query, view);
            }
        });
    }
    

    /**
     * 
     * @param {Element} $element 
     * @param {string} base 
     * @param {string} endpoint 
     * @param {array} query
     * @param {string} view 
     * @returns {Promise}
     */
    static html = async ($element, base, endpoint, query, view) => {
        const response = await fetch(VDB_CONFIG.url.root+"/wp-json/"+base+endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-WP-Nonce": VDB_CONFIG.nonce},
            body: JSON.stringify({query, view})
        });
        const datas = await response.json();console.log({datas});
    
        if(response.ok){
            if($element && datas.success){
                if($element.dataset.keepwrap === "true"){
                    $element.innerHTML = datas.html;
                    Posts.emitPostsloaded($element, view, response.ok);
                } else {
                    const $parent = $element.parentNode;
                    $element.insertAdjacentHTML('afterend', datas.html);
                    $element.remove();
                    Posts.emitPostsloaded($parent, view, response.ok);
                }
            }           
        } //else Posts.emitPostsloaded($element, view, response.ok);
        return datas;
    }


    /**
     * Emet l'event "postloaded"
     * @param {Element} $element 
     * @param {function} getLoaded
     * @param {boolean} success
     */
    static emitPostsloaded($element, view, success){
        $element.dispatchEvent(
            new CustomEvent("postsloaded", {
                detail: { success, getLoaded:() => [...$element.querySelectorAll(`data-view=${view}`)] }
            })
        );          
    }
}